/**
 * The shell's own company lookup.
 *
 * Only one thing needs it: resolving a `/companies/<id>/…` path segment to the
 * company's name, so the breadcrumb reads "Acme Pharma Distribution" rather
 * than the generic "Details" crumb — or, before that fallback existed, the raw
 * internal id title-cased into the trail (QA ledger PERM-003).
 *
 * Deliberately not imported from admin-ui: the routes that need this live in the
 * shell, and the shell does not depend on that plugin's API layer.
 */
import apiClient from './client';

export interface CompanySummary {
  id: string;
  name: string;
}

export const getCompanySummary = async (id: string): Promise<CompanySummary> => {
  const response = await apiClient.get<{ success: boolean; data: CompanySummary }>(
    `/api/companies/${id}`
  );
  return response.data.data;
};

export interface CompanyBrandColor {
  brandColor?: string | null;
  brandColorDark?: string | null;
}

/** Sets the company's theme colour — a company admin's own company, or any as platform admin. */
export const updateCompanyBrandColor = async (
  id: string,
  colors: CompanyBrandColor
): Promise<CompanyBrandColor> => {
  const response = await apiClient.put<{ success: boolean; data: CompanyBrandColor }>(
    `/api/companies/${id}/brand-color`,
    colors
  );
  return response.data.data;
};
